module.exports = __webpack_public_path__ + "VijaySivatejMareedu-47b426b7.webp";